import { tx, txt, useContent } from "@/content/ContentContext";
const TILES = () => ([
  [tx("landing.tapal_tea_190g"), "480.00"],
  [tx("landing.milkpak_1l"), "290.00"],
  [tx("landing.dawn_bread"), "200.00"],
  [tx("landing.coca_cola_1_5l"), "220.00"],
  [tx("landing.basmati_1kg"), "420.00"],
  [tx("landing.lux_soap"), "140.00"],
  [tx("landing.surf_excel"), "390.00"],
  [tx("landing.farm_eggs"), "360.00"],
  [tx("landing.lay_s_classic"), "100.00"],
]);

function Tablet() {
  return (
    <div className="rounded-[22px] bg-slate-800 p-2.5 shadow-[0_40px_80px_-30px_rgba(2,6,23,0.9)] ring-1 ring-white/10">
      <div className="overflow-hidden rounded-[14px] bg-slate-50">
        <div className="flex h-8 items-center gap-1.5 bg-slate-950 px-3">
          <span className="h-3 w-3 rounded-[4px] bg-amber-500" />
          <span className="whitespace-nowrap font-display text-[9px] font-bold text-white">{txt("landing.smart_in")}</span>
          <span className="ml-auto rounded-full bg-white/10 px-2 py-0.5 font-mono text-[6.5px] uppercase tracking-wider text-slate-300">{txt("landing.14_days_left")}</span>
        </div>
        <div className="flex min-h-[290px]">
          <div className="grid flex-1 grid-cols-3 content-start gap-1.5 p-2.5">
            {TILES().map(([n, p], i) => (
              <div key={n} className={`rounded-md border bg-white p-1.5 ${i === 3 ? "border-slate-900" : "border-slate-200"}`}>
                <div className="truncate text-[7px] font-semibold text-slate-800">{n}</div>
                <div className="mt-6 flex items-center justify-between">
                  <span className="font-mono text-[7.5px] font-bold">{p}</span>
                  <span className="h-2.5 w-2.5 rounded-[3px] bg-slate-900" />
                </div>
              </div>
            ))}
          </div>
          <div className="w-[38%] bg-slate-900 p-1.5">
            <div className="slot !h-1.5" />
            <div className="mx-1 bg-[#fffdfa] px-1.5 py-2 font-mono text-[6.5px] text-slate-700">
              <div className="text-center font-bold tracking-widest">{txt("landing.fresh_mart")}</div>
              <div className="my-1 border-t border-dashed border-slate-300" />
              {[[tx("landing.coca_cola_x3"), "660.00"], [tx("landing.milkpak_x1"), "290.00"], [tx("landing.dawn_bread"), "200.00"]].map(([a, b]) => (
                <div key={a} className="flex justify-between"><span>{a}</span><span>{b}</span></div>
              ))}
              <div className="my-1 border-t border-dashed border-slate-300" />
              <div className="flex justify-between text-[8px] font-bold"><span>{txt("landing.total")}</span><span>1,150.00</span></div>
            </div>
            <div className="mx-1 mt-1.5 rounded bg-amber-500 py-1 text-center font-display text-[7.5px] font-bold text-slate-950">{txt("landing.charge")}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Phone() {
  return (
    <div className="w-[150px] rounded-[26px] bg-slate-950 p-1.5 shadow-[0_30px_60px_-20px_rgba(2,6,23,0.9)] ring-1 ring-white/15">
      <div className="overflow-hidden rounded-[20px] bg-slate-50">
        <div className="h-5 bg-slate-950" />
        <div className="grid grid-cols-2 gap-1 p-1.5">
          {[[tx("landing.panadol_500mg"), "0.400"], [tx("landing.augmentin_625"), "2.350"], [tx("landing.brufen_400"), "0.700"], [tx("landing.calpol_120ml"), "0.700"]].map(([n, p]) => (
            <div key={n} className="rounded-md border border-slate-200 bg-white p-1">
              <div className="truncate text-[6.5px] font-semibold">{n}</div>
              <div className="mt-1.5 font-mono text-[7px] font-bold">OMR {p}</div>
              <div className="mt-1 truncate rounded bg-emerald-50 px-0.5 font-mono text-[5px] text-emerald-700">{txt("landing.b_pn_2611_nov_26")}</div>
            </div>
          ))}
        </div>
        <div className="m-1.5 flex items-center gap-1 rounded-lg bg-slate-950 p-1.5">
          <span className="grid h-4 w-4 place-items-center rounded bg-amber-500 font-mono text-[7px] font-bold">3</span>
          <span className="font-mono text-[7px] font-bold text-white">{txt("landing.omr_3_450")}</span>
          <span className="ml-auto rounded bg-amber-500 px-1.5 py-0.5 font-display text-[7px] font-bold">{txt("landing.charge")}</span>
        </div>
      </div>
    </div>
  );
}

export function HeroMockup() {
  useContent();
  return (
    <div className="relative mx-auto w-full max-w-[560px]" aria-hidden="true" data-testid="hero-mockup">
      <div className="absolute -inset-10 rounded-full bg-amber-500/15 blur-[90px]" />
      <div className="relative rotate-[-2deg]"><Tablet /></div>
      <div className="absolute -bottom-10 -left-4 rotate-[5deg] sm:-left-10"><Phone /></div>
      <div className="absolute -right-2 -top-6 rotate-[6deg] rounded-xl bg-[#fffdfa] px-3 py-2 font-mono text-[10px] text-slate-700 shadow-xl sm:-right-6">
        <div className="font-bold text-emerald-700">{txt("landing.fefo_picked")}</div>
        <div>{txt("landing.b_pn_26112_exp_19")}</div>
      </div>
    </div>
  );
}
